/**
 * TanStack Query hook for provider comparison
 */

import { useQuery } from "@tanstack/react-query";
import { providerService } from "@/lib/api/services/provider";
import type { ProviderComparisonRequest } from "@/types/provider";

export function useProviderComparison(request: ProviderComparisonRequest | null) {
  return useQuery({
    queryKey: ["provider-comparison", request],
    queryFn: () => {
      if (!request) {
        throw new Error("Provider comparison request is required");
      }
      return providerService.compare(request);
    },
    enabled: !!request && !!request.from && !!request.to && !!request.amount && request.amount > 0,
    staleTime: 0,
    retry: 1,
  });
}
